import { Component, OnInit, LOCALE_ID, Inject} from '@angular/core';
import { PageItem } from '../page';
import { InterviewItem } from '../interview';
import { DedaloService } from '../dedalo.service';
import { Entrevista } from '../entrevista';
import { ActivatedRoute,Router, NavigationEnd } from "@angular/router";
import { PageService } from '../page.service';

@Component({
  selector: 'app-interview',
  templateUrl: './interview.component.html',
  styleUrls: ['./interview.component.css']
})
export class InterviewComponent implements OnInit {

  pages : PageItem[];
  interviews : InterviewItem[];
  entrevistas : Entrevista[];
  entrevistaID: string;
  single: boolean = false;
  loading: boolean = true;
  _MEDIAURL = 'https://www.industriapaisaia.eus';


  constructor(
    private entrevistaService : DedaloService,
    private route: ActivatedRoute,
    @Inject(LOCALE_ID) protected localeId: string,
    private pageService: PageService,
  ) {}

  ngOnInit() {
    this.getEntrevistas()
    this.route.params.subscribe( params => {
      this.entrevistaID = params.id
      if (params.id) this.single = true
    });
  }

  getInterviews() : void {
    this.interviews = [];
  }

  getEntrevistas() {
    this.entrevistaService.getInterviews()
    .subscribe(data => {
      // data.result.forEach( (e) => {
      //   e.audiovisal.forEach( (v) => {
      //     v.video = v.video.replace(/^.*[\\\/]/, '')
      //   })
      // })

      // console.log(this.localeId)
      this.entrevistas = data.result

      // TODO: Hacer peticion a Worpdress en vez de este sistema hardcoded..
      let p;
      switch (this.localeId) {
        case "es":
          this.entrevistas = this.entrevistas.filter(entrevista => entrevista.lang == 'lg-spa');
          p = new PageItem('0','Entrevistas','Entrevistas en audio y vídeo del proyecto "Paisaje industrial"','','entrevistas','0');
          p.language = {current:'entrevistas',es:{slug:'entrevistas'},eu:{slug:'elkarrizketak'}};
          break;
        case "eu":
          this.entrevistas = this.entrevistas.filter(entrevista => entrevista.lang == 'lg-eus');
          p = new PageItem('0','Elkarrizketak','"Industria paisaia" proiektuaren inguruan egindako elkarrizketak, audian eta bideoan','','elkarrizketak','0');
          p.language = {current:'elkarrizketak',es:{slug:'entrevistas'},eu:{slug:'elkarrizketak'}};
          break;
        default:
          this.entrevistas = this.entrevistas.filter(entrevista => entrevista.lang == 'lg-eus');
          p = new PageItem('0','Elkarrizketak','"Industria paisaia" proiektuaren inguruan egindako elkarrizketak, audian eta bideoan','','elkarrizketak','0');
          p.language = {current:'elkarrizketak',es:{slug:'entrevistas'},eu:{slug:'elkarrizketak'}};
      }
      // --- end TODO --

      p['background_image']="https://backend.industriapaisaia.eus/wp-content/uploads/2022/03/ZM_Industria_Paisaia_Elkarrizketatuak_202203-1.jpg"
      this.pages = [p];
      this.pageService.currentPage = p
      // console.log(this.entrevistas)
      // console.log(this.pages)

      if (this.entrevistaID) {
        this.entrevistas = this.entrevistas.filter(entrevista => entrevista.id == this.entrevistaID)
        if(this.entrevistas[0].title) { this.pages[0].title = this.entrevistas[0].title; }
        if(this.entrevistas[0].abstract) { this.pages[0].excerpt = this.entrevistas[0].abstract; }
        if(this.entrevistas[0].image) { this.pages[0].background_image = this._MEDIAURL+this.entrevistas[0].image[0].src; }
      }
    })
  }

}
